module.exports = __webpack_public_path__ + "assets/img/3_1223.57f9eba4.jpg";